import React from 'react';
import { Coins, Gift, Target, Crown } from 'lucide-react';
import { REWARDS, SITE, SOCIALS } from '../mock';
import { useReveal } from '../hooks/useReveal';
import { TermsPanel } from './TermsPanel';

const ICONS = { Coins, Gift, Target, Crown };

export default function Rewards() {
  useReveal();

  const ctaHref = (type) => {
    if (type === 'discord') return SOCIALS.discord;
    if (type === 'vip') return '#vip';
    return SITE.roobetRef;
  };

  return (
    <section id="rewards" className="py-16 sm:py-24 relative">
      <div className="ar-container">
        <div className="text-center mb-10 sm:mb-14 reveal">
          <p className="ar-eyebrow mb-3">Rewards</p>
          <h2 className="ar-heading text-3xl sm:text-4xl md:text-5xl mb-4">Rewards &amp; <span className="text-cyan">Benefits</span></h2>
          <p className="text-muted max-w-2xl mx-auto">Each card shows who provides the benefit. Open Eligibility &amp; Terms for the conditions that apply.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REWARDS.map((r, i) => {
            const Icon = ICONS[r.icon] || Gift;
            const isVip = r.cta.type === 'vip';
            const external = r.cta.type === 'discord' || r.cta.type === 'roobet';
            return (
              <div key={r.key} data-testid={`reward-card-${r.key}`} className="ar-panel ar-panel-hover p-8 reveal reveal-scale flex flex-col" style={{ animationDelay: `${i * 0.12}s`, borderColor: isVip ? 'var(--ar-border-cyan)' : undefined }}>
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6" style={{ background: 'rgba(0,217,255,0.1)', border: '1px solid rgba(0,217,255,0.3)' }}>
                  <Icon size={30} className="text-cyan" aria-hidden="true" />
                </div>
                <span data-testid={`reward-provider-${r.key}`} className="self-start text-[10px] font-display font-bold tracking-[0.18em] px-2.5 py-1 rounded-full mb-3" style={{ background: r.provider === 'Roobet' ? 'rgba(255,255,255,0.06)' : 'rgba(0,217,255,0.1)', color: r.provider === 'Roobet' ? 'var(--ar-text)' : 'var(--ar-cyan)', border: '1px solid var(--ar-border)' }}>PROVIDED BY {r.provider.toUpperCase()}</span>
                <h3 className="font-display font-bold text-xl mb-5 tracking-wide">{r.title}</h3>
                <ul className="space-y-3 mb-5 flex-1">
                  {r.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-sm text-muted">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: 'var(--ar-cyan)' }} />
                      {p}
                    </li>
                  ))}
                </ul>
                <TermsPanel terms={r.terms} testId={`reward-terms-btn-${r.key}`} />
                <a data-testid={`reward-cta-${r.key}`}
                  href={ctaHref(r.cta.type)}
                  target={external ? '_blank' : undefined}
                  rel={external ? 'noopener noreferrer' : undefined}
                  className={`${r.cta.type === 'discord' ? 'btn-ghost' : 'btn-gold'} w-full`}
                >
                  {r.cta.label}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
